import dayjs from "dayjs";

export const getTemplateFilename = (
  type: "import" | "update" | "import-error" | "imported",
  prefix?: string,
) => {
  return `${prefix ? `${prefix}-` : ""}${type}-${dayjs().format(
    "YYYY-MM-DDTHH_mm_ss",
  )}.csv`;
};
